import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Ecran de întoarcere din Stripe Checkout — verifică statutul plății prin
// polling (webhook-ul poate întârzia), apoi actualizează contul la Premium.
export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { getPaymentStatus, checkAuth } = useAuth();
  const [status, setStatus] = useState("verificare"); // verificare | platit | eroare
  const navigate = useNavigate();
  const triesRef = useRef(0);

  useEffect(() => {
    if (!sessionId) {
      setStatus("eroare");
      return;
    }
    let stopped = false;
    const poll = async () => {
      try {
        const r = await getPaymentStatus(sessionId);
        if (r.payment_status === "paid") {
          await checkAuth();
          if (!stopped) setStatus("platit");
          return;
        }
      } catch {
        // reîncercăm
      }
      triesRef.current += 1;
      if (triesRef.current >= 10) {
        if (!stopped) setStatus("eroare");
        return;
      }
      if (!stopped) setTimeout(poll, 2000);
    };
    poll();
    return () => {
      stopped = true;
    };
  }, [sessionId]);

  return (
    <div
      data-testid="payment-success-page"
      className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
    >
      {status === "verificare" && (
        <>
          <Loader2 className="h-10 w-10 animate-spin text-slate-400" />
          <p className="mt-4 font-semibold text-slate-600">Confirmăm plata ta...</p>
        </>
      )}
      {status === "platit" && (
        <>
          <CheckCircle2 className="h-16 w-16" style={{ color: "#12b981" }} strokeWidth={2} />
          <h1 className="font-heading text-2xl font-black mt-4" style={{ color: "#0f1b2d" }}>
            Bine ai venit la Premium!
          </h1>
          <p className="text-sm text-slate-500 mt-1">
            Plata a fost confirmată. Ai acces la toate avantajele Chit Premium.
          </p>
          <button
            data-testid="payment-success-continue-btn"
            onClick={() => navigate("/premium")}
            className="mt-6 w-full max-w-xs py-3.5 rounded-2xl font-bold text-white active:scale-95 transition-transform"
            style={{ backgroundColor: "#12b981" }}
          >
            Continuă
          </button>
        </>
      )}
      {status === "eroare" && (
        <>
          <XCircle className="h-16 w-16 text-rose-500" strokeWidth={2} />
          <h1 className="font-heading text-2xl font-black mt-4" style={{ color: "#0f1b2d" }}>
            Nu am putut confirma plata
          </h1>
          <p className="text-sm text-slate-500 mt-1">
            Dacă banii au fost reținuți, Premium se va activa în câteva minute. Altfel, încearcă din nou.
          </p>
          <button
            data-testid="payment-error-back-btn"
            onClick={() => navigate("/premium")}
            className="mt-6 w-full max-w-xs py-3.5 rounded-2xl border border-slate-200 text-slate-600 font-semibold"
          >
            Înapoi la Premium
          </button>
        </>
      )}
    </div>
  );
}
